import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMe } from '../api/authApi';
import { theme } from '../adminTheme';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      const me = await getMe();
      if (me.data.role !== 'admin') {
        setError('Acceso denegado: solo administradores');
        return;
      }
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Sumabit</h1>
        <p style={styles.subtitle}>Panel de Administración</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} style={styles.input} required placeholder="admin@email.com" />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={styles.input} required />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    minHeight: '100vh', backgroundColor: theme.bg,
  },
  card: {
    backgroundColor: theme.card, padding: '40px', borderRadius: '12px',
    border: `1px solid ${theme.border}`, width: '100%', maxWidth: '400px',
  },
  title: { textAlign: 'center', margin: '0 0 4px 0', color: theme.text, fontSize: '2rem' },
  subtitle: { textAlign: 'center', margin: '0 0 24px 0', color: theme.textMuted, fontSize: '1rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  field: { display: 'flex', flexDirection: 'column', gap: '4px' },
  label: { fontSize: '0.875rem', fontWeight: 500, color: theme.textMuted },
  input: {
    padding: '10px 12px', border: `1px solid ${theme.inputBorder}`, borderRadius: '8px',
    fontSize: '1rem', outline: 'none', backgroundColor: theme.input, color: theme.text,
  },
  error: { color: theme.error, fontSize: '0.875rem', margin: 0, textAlign: 'center' },
  button: {
    padding: '12px', backgroundColor: theme.accent, color: '#fff',
    border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: 500,
    cursor: 'pointer', marginTop: '8px',
  },
};
